export default class DynamicComparison {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.groupsCollapsed = true;
    this.overflowLimit = 5;

    this.selectors = {
      comparisonGroup: '[data-comparison-group]',
      comparisonGroupButton: '[data-comparison-group-button]',
    };

    this.comparisonGroups = this.el.querySelectorAll(
      this.selectors.comparisonGroup,
    );
    this.comparisonGroupButtons = this.el.querySelectorAll(
      this.selectors.comparisonGroupButton,
    );

    this.hasOverflow = [...this.comparisonGroups].some(group => {
      const listItems = group.querySelectorAll('li');

      return listItems.length > this.overflowLimit;
    });

    if (this.hasOverflow) {
      this._bindEvents();
    }
  }

  _bindEvents() {
    this.comparisonGroupButtons.forEach(button => {
      button.classList.remove('hidden');
      button.addEventListener('click', () => this._toggleGroupsCollapsed());
    });
  }

  _toggleGroupsCollapsed() {
    this.comparisonGroups.forEach(group => {
      group.classList.toggle('comparison-group--collapsed');
    });

    this.groupsCollapsed = !this.groupsCollapsed;

    this.comparisonGroupButtons.forEach(button => {
      button.setAttribute('aria-expanded', this.groupsCollapsed);

      button.querySelectorAll('span').forEach(span => {
        span.classList.toggle('hidden');
        span.classList.toggle('flex');
      });
    });
  }
}
